export const BOTTOM_JUMP_BUTTON_DISPLAY_OFFSET = 50;
export const ESCAPE_KEY = 'Escape';
export const DEEP_RESEARCH_NOTIFICATION_JIGGLE = 'deep_research_notification_jiggle';
export const HAS_SEEN = 'has_seen';
export const NEW_QUERY = 'New query';
export const ONE_YEAR_IN_DAYS = 365;
export const THROTTLE_DURATION = 200;
export const VIEW_NOTIFICATION_SETTINGS = 'View notification settings';

export const BUTTON_STATUS_CLASSES = {
  Active: 'border-current border-solid border-grayscale-gray bg-white text-grayscale-gray',
  Disabled:
    'disabled:border-transparent disabled:bg-grayscale-gray/50 disabled:text-grayscale-gray',
};

export const NOTIFICATION_BUTTON_TOASTS = {
  Error: 'Sorry, we weren’t able to create that notification right now. Please try again later',
  Subscribed: 'You’re now subscribed to email updates related to this query thread',
  Unsubscribed: 'You’re now unsubscribed from email updates related to this query thread',
};

export const NOTIFICATION_BUTTON_LABELS = {
  Subscribe: {
    aria: 'Get notified when new reporting updates your response',
    tooltip: 'Notify me when new reporting updates this response',
  },
  Unsubscribe: {
    aria: 'Unsubscribe from notification when reporting updates your response',
    tooltip: 'You will be notified when new reporting updates this response',
  },
};

export enum CloseButtonTypes {
  Close = 'close',
  Escape = 'escape',
  Icon = 'icon',
  Overlay = 'overlay',
}
